import { initializeApp} from "firebase/app";
import {getFirestore} from "@firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAccKu6M72kT--MXKbuCAPe2b_eVoEYYwM",
  authDomain: "dollarstore-eab75.firebaseapp.com",
  databaseURL: "https://dollarstore-eab75.firebaseio.com",
  projectId: "dollarstore-eab75",
  storageBucket: "dollarstore-eab75.appspot.com",
  messagingSenderId: "301136163348",
  appId: "1:301136163348:web:58bde8e7bfffce7d92ad01",
  measurementId: "G-PCVHLQXEFY"
};

  const app =initializeApp(firebaseConfig);
  const storage = getStorage(app);

  export { storage, ref, uploadBytes, getDownloadURL };
  export const db = getFirestore(app);
  export const auth = getAuth(app);
  


